import {useIntl} from 'react-intl'
import {Routes, Route, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { EventsOccurrencies } from './EventsOccurrencies'
import { EventsDuration } from './EventsDuration'
import { SystemEventsTrend } from './SystemEventsTrend'
import { SingleServer } from './SingleServer'

export const DiagnostiRoutes = () => {
  const intl = useIntl()
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.DIAGNOSTICS'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route
        path='events-occurrencies'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.DIAGNOSTICS.DIAGNOSTIC_EVENTS_OCCURRENCIES'})}
            </PageTitle>
            <EventsOccurrencies />
          </>
        }
      />
      <Route
        path='events-duration'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.DIAGNOSTICS.DIAGNOSTIC_EVENTS_DURATIOIN'})}
            </PageTitle>
            <EventsDuration />
          </>
        }
      />
      <Route
        path='system'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.DIAGNOSTICS.SYSTEM'})}
            </PageTitle>
            <SystemEventsTrend />
          </>
        }
      />
       <Route
        path='single'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.DIAGNOSTICS.SINGLE'})}
            </PageTitle>
            <SingleServer />
          </>
        }
      />
      
       <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}
